import type { AppsMultiLanguageSettingsValidateTranslationUsageResult } from "../types";

export const fakeAppsMultiLanguageSettingsValidateTranslationUsageResult: AppsMultiLanguageSettingsValidateTranslationUsageResult =
  {
    warnings: {
      incorrect_html_class_wrapping: [],
      query_param_in_translation: [],
      href_in_translation: [],
      url_protocol_in_translation: [],
      landing_page_liquid_in_translation: [],
      translation_tag_in_href: [],
    },
  };
